import React from 'react';
import { Box, Relative, Text } from 'pcln-design-system';
import { PriceCurrency, PriceCurrencyStrikeThrough, TextStrikeThrough } from '../../HotlListingCard.styles';
const Price = ({
  price,
  totalPrice,
  currency,
  strikeThroughPrice
}) => {
  return React.createElement(Box, {
    textAlign: 'right'
  }, strikeThroughPrice ? React.createElement(Relative, null, React.createElement(TextStrikeThrough, {
    lineHeight: '22px'
  }, React.createElement(PriceCurrencyStrikeThrough, {
    fontSize: '8px',
    fontWeight: 'bold'
  }, currency), React.createElement(Text.span, {
    fontSize: 1,
    fontWeight: 'bold'
  }, Math.round(parseInt(strikeThroughPrice))))) : null, React.createElement(Text, {
    color: 'pricePrimary.base',
    lineHeight: '22px'
  }, ' ', React.createElement(PriceCurrency, {
    fontSize: 0,
    fontWeight: 'bold'
  }, currency), React.createElement(Text.span, {
    fontSize: 4,
    fontWeight: 'bold'
  }, Math.round(parseInt(price)))), React.createElement(Text, {
    fontSize: 0,
    lineHeight: '16px',
    color: 'text.light'
  }, "Total: ", currency, Math.round(parseInt(totalPrice))));
};
export default Price;